import { Component } from '@angular/core';

@Component({
  selector: 'r2e-sygnet',
  templateUrl: './sygnet.component.svg',
  styleUrl: './logo.component.scss'
})
export class SygnetComponent {}
